// @flow

import { useReducer } from 'react';
import type { PaymentData, PaymentAction } from '../context';

const INITIAL_DATA: PaymentData = {
  state: 'LOADING',
  paymentHash: '',
  redirectUrlAfterPayment: null,
  errorMessage: '',
  retryState: 'COLLECT_PHONE',
  waitingDeadline: null,
};

function paymentReducer(data: PaymentData, action: PaymentAction): PaymentData {
  switch (action.type) {
    case 'PAYMENT_QUERY_SUCCESS':
      return {
        ...data,
        state: 'COLLECT_PHONE',
        redirectUrlAfterPayment: action.redirectUrlAfterPayment,
      };

    case 'START_SUBMITTING':
      return { ...data, state: 'SUBMITTING' };

    case 'START_WAITING_APPROVAL':
      return {
        ...data,
        state: 'WAITING_APPROVAL',
        waitingDeadline: action.waitingDeadline,
      };

    case 'START_AWAITING_PAYMENT_STATUS':
      return {
        ...data,
        state: 'AWAITING_PAYMENT_STATUS',
        waitingDeadline: action.waitingDeadline,
      };

    case 'SET_WAITING_DEADLINE':
      return { ...data, waitingDeadline: action.waitingDeadline };

    case 'PAYMENT_CONFIRMED':
      return { ...data, state: 'SUCCESS', waitingDeadline: null };

    case 'SET_TIMEOUT':
      return { ...data, state: 'TIMEOUT' };

    case 'RESTART_COLLECT_PHONE':
      return {
        ...data,
        state: 'COLLECT_PHONE',
        errorMessage: '',
        waitingDeadline: null,
      };

    case 'SET_ERROR':
      return {
        ...data,
        state: 'ERROR',
        errorMessage: action.errorMessage,
        retryState: action.retryState,
      };

    case 'RETRY':
      return { ...data, state: data.retryState, errorMessage: '' };

    default:
      return data;
  }
}

type InitArgs = {| +paymentHash: string |};

function init(args: InitArgs): PaymentData {
  return {
    ...INITIAL_DATA,
    paymentHash: args.paymentHash,
  };
}

export function usePaymentState(
  paymentHash: string,
): [PaymentData, (PaymentAction) => void] {
  return useReducer(paymentReducer, { paymentHash }, init);
}
